
import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import '@/styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
      <footer className="w-full bg-background mt-6">
          <span style={{display: 'none'}}>
            Credits for waves: https://codepen.io/goodkatz/pen/LYPGxQz
          </span>
          <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
               viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
              <defs>
                  <path id="gentle-wave"
                        d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"/>
              </defs>
              <g className="parallax">
                  <use xlinkHref="#gentle-wave" x="48" y="0" className="wave1"/>
                  <use xlinkHref="#gentle-wave" x="48" y="3" className="wave2"/>
                  <use xlinkHref="#gentle-wave" x="48" y="5" className="wave3"/>
                  <use xlinkHref="#gentle-wave" x="48" y="7" className="wave4"/>
              </g>
          </svg>
      </footer>
  );
};

export default Footer;
